import React, { useEffect, useState } from "react";
import axios from "axios";

const ShowRoomBaghdadHeroEditor = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [data, setData] = useState(null);
  const [msg, setMsg] = useState("");

  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: ""
  });

  const [imgFile, setImgFile] = useState(null);

  // ============================
  // LOAD ALL LANGUAGES
  // ============================
  useEffect(() => {
    const load = async () => {
      try {
        const en = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadHero?lang=en`
        );
        const ar = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadHero?lang=ar`
        );
        const ku = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadHero?lang=ku`
        );

        setData(en.data);

        setForm({
          titleEn: en.data.title || "",
          titleAr: ar.data.title || "",
          titleKu: ku.data.title || "",
        });

      } catch (err) {
        console.error("Failed loading ShowRoomBaghdadHero:", err);
      }
    };

    load();
  }, [API_BASE]);

  if (!data) return <p className="p-4">Loading...</p>;

  // ============================
  // UPDATE TEXT
  // ============================
  const saveText = async () => {
    try {
      await axios.put(
        `${API_BASE}/api/ShowRoomBaghdadHero/1`,
        form,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setMsg("Text updated successfully.");
    } catch (err) {
      console.error(err);
      setMsg("Failed to update text.");
    }
  };

  // ============================
  // UPLOAD IMAGE
  // ============================
  const uploadImage = async () => {
    if (!imgFile) {
      setMsg("Please select an image first.");
      return;
    }

    const fd = new FormData();
    fd.append("ImageFile", imgFile);
    fd.append("Replace", true);

    try {
      await axios.post(
        `${API_BASE}/api/ShowRoomBaghdadHero/1/media`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMsg("Image updated successfully.");

    } catch (err) {
      console.error(err);
      setMsg("Failed to upload image.");
    }
  };

  return (
    <div className="p-4">
      <h2>ShowRoom Baghdad Hero Editor</h2>

      {msg && <div className="alert alert-info mt-3">{msg}</div>}

      {/* =============================== */}
      {/* IMAGE PREVIEW TABLE             */}
      {/* =============================== */}
      <table className="table table-bordered mt-4">
        <thead className="table-dark">
          <tr>
            <th>Slot</th>
            <th>Preview</th>
            <th>Upload New</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Background Hero Image</td>
            <td>
              <img
                src={API_BASE + data.backgroundImage}
                alt="hero"
                style={{
                  width: "250px",
                  borderRadius: "6px",
                  objectFit: "cover"
                }}
              />
            </td>
            <td style={{ width: "260px" }}>
              <input
                type="file"
                className="form-control mb-2"
                onChange={(e) => setImgFile(e.target.files[0])}
              />
              <button
                className="btn btn-dark w-100"
                onClick={uploadImage}
              >
                Upload
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* =============================== */}
      {/* TEXT FIELDS                     */}
      {/* =============================== */}

      <h4 className="mt-5 mb-3">Hero Title</h4>

      <label className="fw-bold">Title (English)</label>
      <input
        className="form-control mb-3"
        value={form.titleEn}
        onChange={(e) => setForm({ ...form, titleEn: e.target.value })}
      />

      <label className="fw-bold">Title (Arabic)</label>
      <input
        className="form-control mb-3"
        value={form.titleAr}
        onChange={(e) => setForm({ ...form, titleAr: e.target.value })}
      />

      <label className="fw-bold">Title (Kurdish)</label>
      <input
        className="form-control mb-4"
        value={form.titleKu}
        onChange={(e) => setForm({ ...form, titleKu: e.target.value })}
      />

      <button
        className="btn btn-primary w-100"
        onClick={saveText}
      >
        Save Text
      </button>
    </div>
  );
};

export default ShowRoomBaghdadHeroEditor;
